import React, { useContext } from "react";

import { Redirect, Route } from "react-router-dom";
import { SessionContext } from "../../context/session.context";

export default function PrivateRoute({ children, ...rest }) {
  const { isLoggedIn } = useContext(SessionContext);

  return (
    <Route
      {...rest}
      render={({ location }) =>
        isLoggedIn ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}
